import React from "react";
import messageConfig from "../../config/messageConfig";
import { systemNotifications } from "../../constants/commonConstants";

const SystemMessage = ({
  onClick,
  message,
  revisionReference = null,
  providedSolution = null,
  date,
  time,
  isLast,
  isSingleInGroup,
  handleButtonClick,
  isLastWithinGroup = false
}) => {
  const config = messageConfig[message] || {};
  const { button, action } = config;

  // Handle button click actions
  const handleClick = () => {
    if (action) action(); // Execute custom action if defined

    const actionMap = {
      "View Requirements": "view-requirements",
      "Pay Now": "pay-now",
      "Review Order": "review-order",
      "View Complaint": "view-complaint",
      "View Revision": "view-revision",
    };

    if (actionMap[button]) {
      handleButtonClick(actionMap[button], revisionReference);
      console.log("revisionReference:" , revisionReference);
      
    } else {
      console.error("Unhandled Button:", button);
    }
  };

  return (
    <div
      className={` relative flex flex-col lg:flex-row items-start xl:items-center space-x-2 p-2 bg-gray-200 text-gray-800 rounded-md ${
        isLastWithinGroup ? "mb-0 ml-2 mt-0" : "mb-2"
      }`}
    >
      {/* Vertical line for grouped messages */}
      { !isSingleInGroup && !isLastWithinGroup && (
        <div className="lg:block hidden absolute top-[30px] left-[19px] rounded-full h-6 w-[2px] mb-2 bg-[#d8dbe4]"></div>
      )}

      {/* Message text with indicator */}
      <div className="flex items-center font-inter font-medium text-[#83899f] text-level-4 leading-5 z-5">
       
        <div
          className={`min-w-[8px] min-h-[8px] ${
            isLast ? "bg-blue-shades" : "bg-[#d8dbe4]"
          } mr-2 rounded-full`}
        ></div>
        {message} {message === systemNotifications.COMPLAINET_RESOLVED && providedSolution ? ` :- ${providedSolution}` : ''}
        </div>
       
      {/* Date and Time display */}
      <div className="flex flex-row  justify-end">
      <span className="font-inter ml-4 mt-1 lg:ml-2 font-normal text-[10px] italic leading-5 text-[#83899f] z-5">
         {time && <span className="py-1">{time}</span>}
      </span>
      {/* Action button */}
      {button && (
        <button
          onClick={handleClick}
          className="ml-auto px-3 py-1 bg-none text-blue-shades text-level-5 font-medium underline"
        >
          {button}
        </button>
      )}
      
       
      </div>

     

      
    </div>
  );
};


export default SystemMessage;
